import React from 'react';
import { Link } from 'react-router';
import { Button, Icon } from '@unite-us/app-components';
import { get } from 'lodash';

const getClientsDetailLink = ({
  person,
  onClick,
  type = 'link', // 'button' | 'link' | 'text' | 'name'
  textSize = 'text-sm', // e.g., 'text-sm', 'text-base', 'text-lg', etc.
  className = '',
  dataTestId,
  showArrow = true, // Whether to show ">" arrow for button type
  nameFormat = 'full', // 'full' | 'lastFirst' | 'firstLast'
  ariaLabel,
  // Optional props for fallback display when person is incomplete
  fallbackName,
  fallbackId,
  arrowSize = '16', // Size in pixels for the arrow icon
  // Legacy props for backwards compatibility
  clientName,
  clientId,
}) => {
  // Extract person data - support both person object and fallback props
  const firstName = get(person, 'first_name') || '';
  const lastName = get(person, 'last_name') || '';
  const personId = get(person, 'id') || fallbackId || clientId;

  // Format name based on nameFormat parameter
  let displayName;
  if (nameFormat === 'lastFirst' && firstName && lastName) {
    displayName = `${lastName}, ${firstName}`;
  } else if (nameFormat === 'firstLast' && firstName && lastName) {
    displayName = `${firstName} ${lastName}`;
  } else {
    // Default to full_name or fallback to constructed name
    displayName = get(person, 'full_name') || `${firstName} ${lastName}`.trim() || fallbackName || clientName || '';
  }

  // If no name available, return empty fragment
  if (!displayName) {
    return <></>;
  }

  // Button type - used for drawer interactions
  if (type === 'button') {
    return (
      <Button
        onClick={onClick}
        label={showArrow ? (
          <>
            {displayName}
            <Icon
              icon="ChevronArrow"
              direction="right"
              color="current"
              className="ml-1 mb-0.5"
              size={arrowSize}
            />
          </>
        ) : displayName}
        omitDefaultStyles
        className={`m-0 ${textSize} text-action-blue hover:underline pl-0 pt-0 pb-0 ${className}`}
        link
        data-testid={dataTestId || 'clients-drawer-btn'}
        aria-label={ariaLabel}
      />
    );
  }

  // Link type - used for navigation to facesheet
  if (type === 'link' && personId) {
    return (
      <Link
        to={`/facesheet/${personId}`}
        className={`${textSize} text-action-blue hover:underline ${className}`}
        data-testid={dataTestId || 'client-facesheet-link'}
      >
        {displayName}
      </Link>
    );
  }

  // Name type - backwards compatibility for getClientName usage
  if (type === 'name') {
    // This provides the same behavior as the old getClientName function
    return displayName;
  }

  // Text type - plain text display
  return (
    <span
      className={`${textSize} ${className}`}
      data-testid={dataTestId || 'client-name-text'}
    >
      {displayName}
    </span>
  );
};

export default getClientsDetailLink;
